<h5
  class="flex justify-center md:justify-end items-center gap-1.5 text-main text-sm">
  <img src="/assets/img/clock-icon-blue.svg" alt="" class="w-[15px] h-[15px]" />
  <span class="font-medium">Remaining time:</span>
  <span class="font-bold">{{ getTimer }}</span>
</h5>
